// Auto-generated: top/bottom edge colors of each product photo, used to
// extend the photo's own background gradient behind it (letterbox blend)
// instead of a hard-edged card.
export interface ProductBgGradient { top: string; bottom: string; }
export const productBgColors: Record<string, ProductBgGradient> = {
  "/images/products/alimorca-1000ml.png": {
    "top": "#fdfcf9",
    "bottom": "#f0c720"
  },
  "/images/products/alimorca-18l.png": {
    "top": "#fcfbfb",
    "bottom": "#e3d19b"
  },
  "/images/products/alimorca-430ml.png": {
    "top": "#fcf7e6",
    "bottom": "#f9f9f6"
  },
  "/images/products/alimorca-500ml.png": {
    "top": "#fdf8e8",
    "bottom": "#fefcfa"
  },
  "/images/products/alimorca-750ml.png": {
    "top": "#fdf8e7",
    "bottom": "#fdfcf9"
  },
  "/images/products/alimorca-828ml.png": {
    "top": "#fbf4dc",
    "bottom": "#fdfcf9"
  },
  "/images/products/alimorca-900ml.png": {
    "top": "#efe8d9",
    "bottom": "#fdfcf9"
  },
  "/images/products/alimorca-9l.png": {
    "top": "#fdfbf7",
    "bottom": "#f8ecca"
  },
  "/images/products/alimorca-palma-1000ml.png": {
    "top": "#164b2d",
    "bottom": "#c7b29b"
  },
  "/images/products/alimorca-palma-18l.png": {
    "top": "#0e4629",
    "bottom": "#b67d3e"
  },
  "/images/products/alimorca-palma-430ml.png": {
    "top": "#25522a",
    "bottom": "#d0bfa0"
  },
  "/images/products/alimorca-palma-500ml.png": {
    "top": "#1f512e",
    "bottom": "#d0c0a7"
  },
  "/images/products/alimorca-palma-750ml.png": {
    "top": "#124521",
    "bottom": "#d2bc9f"
  },
  "/images/products/alimorca-palma-828ml.png": {
    "top": "#225331",
    "bottom": "#c9a97c"
  },
  "/images/products/alimorca-palma-900ml.png": {
    "top": "#356243",
    "bottom": "#d1bb9d"
  },
  "/images/products/alimorca-palma-9l.png": {
    "top": "#164a2a",
    "bottom": "#d1ba9c"
  },
  "/images/products/alimorca-soya-1000ml.png": {
    "top": "#104827",
    "bottom": "#d4923b"
  },
  "/images/products/alimorca-soya-18l.png": {
    "top": "#1e4f35",
    "bottom": "#c5893f"
  },
  "/images/products/alimorca-soya-430ml.png": {
    "top": "#1a4c20",
    "bottom": "#d7993c"
  },
  "/images/products/alimorca-soya-500ml.png": {
    "top": "#144a22",
    "bottom": "#d69538"
  },
  "/images/products/alimorca-soya-750ml.png": {
    "top": "#114722",
    "bottom": "#cc903a"
  },
  "/images/products/alimorca-soya-828ml.png": {
    "top": "#184d2a",
    "bottom": "#d5983e"
  },
  "/images/products/alimorca-soya-900ml.png": {
    "top": "#144a27",
    "bottom": "#d79e47"
  },
  "/images/products/alimorca-soya-9l.png": {
    "top": "#0b4322",
    "bottom": "#cd8a30"
  },
  "/images/products/delsarten-1000ml.png": {
    "top": "#fdfcf9",
    "bottom": "#f0c720"
  },
  "/images/products/delsarten-18l.png": {
    "top": "#fcfbfb",
    "bottom": "#e3d19b"
  },
  "/images/products/delsarten-430ml.png": {
    "top": "#fcf7e6",
    "bottom": "#f9f9f6"
  },
  "/images/products/delsarten-500ml.png": {
    "top": "#fdf8e8",
    "bottom": "#fefcfa"
  },
  "/images/products/delsarten-750ml.png": {
    "top": "#fdf8e7",
    "bottom": "#fdfcf9"
  },
  "/images/products/delsarten-828ml.png": {
    "top": "#fbf4dc",
    "bottom": "#fdfcf9"
  },
  "/images/products/delsarten-900ml.png": {
    "top": "#efe8d9",
    "bottom": "#fdfcf9"
  },
  "/images/products/delsarten-9l.png": {
    "top": "#fdfbf7",
    "bottom": "#f8ecca"
  },
  "/images/products/delsarten-maiz.png": {
    "top": "#2cc533",
    "bottom": "#3aca39"
  },
  "/images/products/delsarten-oliva.png": {
    "top": "#fbfbfa",
    "bottom": "#f9f8f8"
  },
  "/images/products/delsarten-palma-1000ml.png": {
    "top": "#d0cbbc",
    "bottom": "#c2ab93"
  },
  "/images/products/delsarten-palma-18l.png": {
    "top": "#cec8b9",
    "bottom": "#ac763c"
  },
  "/images/products/delsarten-palma-430ml.png": {
    "top": "#cbc5b2",
    "bottom": "#d9cec0"
  },
  "/images/products/delsarten-palma-500ml.png": {
    "top": "#cac3b1",
    "bottom": "#d0bda2"
  },
  "/images/products/delsarten-palma-750ml.png": {
    "top": "#cac4b0",
    "bottom": "#d2bc9f"
  },
  "/images/products/delsarten-palma-828ml.png": {
    "top": "#c9c2ae",
    "bottom": "#c9ae8a"
  },
  "/images/products/delsarten-palma-900ml.png": {
    "top": "#d0cbbd",
    "bottom": "#c9ad84"
  },
  "/images/products/delsarten-palma-9l.png": {
    "top": "#cfc9ba",
    "bottom": "#cfb9a2"
  },
  "/images/products/delsarten-pollo-fritas.png": {
    "top": "#e9c69c",
    "bottom": "#b78d53"
  },
  "/images/products/delsarten-pollo-rojo.png": {
    "top": "#b60000",
    "bottom": "#ba0707"
  },
  "/images/products/delsarten-salchicha.png": {
    "top": "#ffc500",
    "bottom": "#fb9906"
  },
  "/images/products/delsarten-soya-1000ml.png": {
    "top": "#d0cabc",
    "bottom": "#d1bea6"
  },
  "/images/products/delsarten-soya-18l.png": {
    "top": "#cec7b7",
    "bottom": "#b2895a"
  },
  "/images/products/delsarten-soya-430ml.png": {
    "top": "#c2baa3",
    "bottom": "#d0bea2"
  },
  "/images/products/delsarten-soya-500ml.png": {
    "top": "#c4bda8",
    "bottom": "#cdbb9f"
  },
  "/images/products/delsarten-soya-750ml.png": {
    "top": "#ccc8b9",
    "bottom": "#ceb793"
  },
  "/images/products/delsarten-soya-828ml.png": {
    "top": "#cbc6b7",
    "bottom": "#d0bc9a"
  },
  "/images/products/delsarten-soya-900ml.png": {
    "top": "#d1cec2",
    "bottom": "#ceba9b"
  },
  "/images/products/delsarten-soya-9l.png": {
    "top": "#ccc5b2",
    "bottom": "#d3c0aa"
  },
  "/images/products/delsarten-vegetales.png": {
    "top": "#ae8f78",
    "bottom": "#bb936a"
  }
};
